/**
 * AdMockupEngagement Component
 *
 * Engagement buttons (Like, Comment, Share) for social media mockups
 */

import React from 'react';
import { cn } from '@/lib/utils';
import { AdMockupEngagementProps } from '../types/base.types';

export const AdMockupEngagement: React.FC<AdMockupEngagementProps> = ({
  platform,
  showCounts = false,
  counts,
}) => {
  const buttonBaseClass = "flex items-center gap-2 text-gray-600 dark:text-gray-400 hover:text-primary dark:hover:text-primary transition-colors";

  if (platform === 'facebook' || platform === 'meta') {
    return (
      <div className="flex justify-between px-4 py-3 border-t border-gray-200 dark:border-border-dark">
        <button className={buttonBaseClass}>
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5" />
          </svg>
          <span className="text-sm font-medium">Like</span>
          {showCounts && counts?.likes && (
            <span className="text-xs">{counts.likes}</span>
          )}
        </button>
        <button className={buttonBaseClass}>
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
          </svg>
          <span className="text-sm font-medium">Comment</span>
          {showCounts && counts?.comments && (
            <span className="text-xs">{counts.comments}</span>
          )}
        </button>
        <button className={buttonBaseClass}>
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
          </svg>
          <span className="text-sm font-medium">Share</span>
          {showCounts && counts?.shares && (
            <span className="text-xs">{counts.shares}</span>
          )}
        </button>
      </div>
    );
  }

  if (platform === 'instagram') {
    return (
      <div className="flex items-center gap-4 px-3 py-2">
        <svg className="w-6 h-6 text-gray-900 dark:text-white hover:text-gray-600 dark:hover:text-gray-400 cursor-pointer transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
        </svg>
        <svg className="w-6 h-6 text-gray-900 dark:text-white hover:text-gray-600 dark:hover:text-gray-400 cursor-pointer transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
        </svg>
        <svg className="w-6 h-6 text-gray-900 dark:text-white hover:text-gray-600 dark:hover:text-gray-400 cursor-pointer transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
        </svg>
      </div>
    );
  }

  return null;
};

export default AdMockupEngagement;
